import { EVENTS } from '../constants'
import { appLoading, appMessage } from './appActions'
import { DB } from '../firebase'

export const getEvents = () => dispatch => {
  let currentDate = new Date()
  currentDate.setDate(currentDate.getDate()-30);

  DB.collection('events')
  .where("date", ">", currentDate)
  .onSnapshot( result => {
    result = result.docs.map( r => {
      const id = r.ref.id
      return { ...r.data(), id }
    })
    dispatch({ type: EVENTS, payload: result })
  })
}

export const updateEventData = eventData => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('events').doc(eventData.id).set(eventData)
  dispatch(appLoading(false))
  dispatch({ type: 'changedDataHandledByListenerAlready' })
}

export const addNewEvent = eventData => async(dispatch) => {
  dispatch(appLoading(true))
  DB.collection('events').add(eventData)
    .then( () => {
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const deleteEvent = eventId => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('events').doc(eventId).delete()
  dispatch(appMessage(`{ok}`))
}


// WEBPACK FOOTER //
// ./src/actions/eventsActions.js